export function formatMoney(number: number) {
  return new Intl.NumberFormat('en-AT', {
    style: 'currency',
    currency: 'EUR',
  }).format(number / 100);
}
